import { render, staticRenderFns } from "./PageBIKES.vue?vue&type=template&id=a8410428"
import script from "./PageBIKES.vue?vue&type=script&lang=js"
export * from "./PageBIKES.vue?vue&type=script&lang=js"
import style0 from "./PageBIKES.vue?vue&type=style&index=0&id=a8410428&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports